import {
    spotservellienceConstants
} from '../_constants';
import {
    spotservellienceService
} from '../_services';
import {
    alertActions
} from './';
import {
    history
} from '../_helpers';
import { pushNotificationService } from '../_services/pushNotification';

export const spotservellienceAction = {
    getSpottype,
    saveQrInformation,
    getQrInformation,
    getQrInformationById,
    getPatrollingPerson
    
}

function getSpottype() {
    return dispatch => {
        dispatch(request());
        spotservellienceService.getSpotType()
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(getSpottype) {
        return {
            type: spotservellienceConstants.GET_SPOTTYPE_REQUEST,
            getSpottype
        }
    }

    function success(getSpottype) {
        return {
            type: spotservellienceConstants.GET_SPOTTYPE_SUCCESS,
            getSpottype
        }
    }

    function failure(error) {
        return {
            type: spotservellienceConstants.GET_SPOTTYPE_FAILURE,
            error
        }
    }
}

function getPatrollingPerson() {
    return dispatch => {
        dispatch(request());
        spotservellienceService.getPatrollingPerson()
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(getPatrollingPerson) {
        return {
            type: spotservellienceConstants.GET_PATROLLING_REQUEST,
            getPatrollingPerson
        }
    }

    function success(getPatrollingPerson) {
        return {
            type: spotservellienceConstants.GET_PATROLLING_SUCCESS,
            getPatrollingPerson
        }
    }

    function failure(error) {
        return {
            type: spotservellienceConstants.GET_PATROLLING_FAILURE,
            error
        }
    }
}

function getQrInformation(cityId) {
    return spotservellienceService.getQrInformation(cityId)
}

// function getQrInformation(cityId) {
//     console.log("cityId",cityId);
//     // return dispatch => {
//     //     dispatch(request());
//     //     spotservellienceService.getQrInformation(cityId)
//     //         .then((response) => {
//     //             dispatch(success(response));
//     //         }, error => {
//     //             dispatch(failure(error));
//     //         })
//     // }

//     // function request(qrInfo) {
//     //     return {
//     //         type: spotservellienceConstants.GET_QRINFO_REQUEST,
//     //         qrInfo
//     //     }
//     // }

//     // function success(qrInfo) {
//     //     return {
//     //         type: spotservellienceConstants.GET_QRINFO_SUCCESS,
//     //         qrInfo
//     //     }
//     // }

//     // function failure(error) {
//     //     return {
//     //         type: spotservellienceConstants.GET_QRINFO_FAILURE,
//     //         error
//     //     }
//     // }
// }

function getQrInformationById(id) {
    return dispatch => {
        dispatch(request());
        spotservellienceService.getQrInformationById(id)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(qrInfo) {
        return {
            type: spotservellienceConstants.GET_QRINFO_REQUEST,
            qrInfo
        }
    }

    function success(qrInfo) {
        return {
            type: spotservellienceConstants.GET_QRINFO_SUCCESS,
            qrInfo
        }
    }

    function failure(error) {
        return {
            type: spotservellienceConstants.GET_QRINFO_FAILURE,
            error
        }
    }
}

function saveQrInformation(data) {
    return dispatch => {
        dispatch(request());
        spotservellienceService.createQrInformation(data)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }
    function request(qrInfo) {
        return {
            type: spotservellienceConstants.SAVE_QRINFO_REQUEST,
            qrInfo
        }
    }
    function success(qrInfo) {
        return {
            type: spotservellienceConstants.SAVE_QRINFO_SUCCESS,
            qrInfo
        }
    }
    function failure(error) {
        return {
            type: spotservellienceConstants.SAVE_QRINFO_FAILURE,
            error
        }
    }
}
